export default __webpack_public_path__ + "static/summary-94ee62e3800a0fd101dd5bd9e569bf06.png";